import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DepartmentResponse, DepartmentStore } from '../types';

// Initial departments list (empty array)
const initialDepartmentsList: DepartmentResponse[] = [];

// Department Store
export const useDepartmentStore = create<DepartmentStore>()(
  devtools(
    (set, get) => ({
      departments: initialDepartmentsList,
      loading: false,
      error: null,

      setDepartments: (departments: DepartmentResponse[]) =>
        set({ departments, error: null }, false, 'setDepartments'),

      setLoading: (loading: boolean) => set({ loading }, false, 'setLoading'),

      setError: (error: string | null) => set({ error, loading: false }, false, 'setError'),

      getDepartmentById: (id: string) => {
        const { departments } = get();
        return departments.find((dept) => dept.id === id);
      },

      getDepartmentByCode: (code: number) => {
        const { departments } = get();
        return departments.find((dept) => dept.code === code);
      },

      clearDepartments: () =>
        set(
          {
            departments: initialDepartmentsList,
            error: null,
            loading: false,
          },
          false,
          'clearDepartments'
        ),
    }),
    {
      name: 'department-store',
    }
  )
);
